import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "'Manrope', sans-serif",
          fontSize: 14,
          fontWeight: 600,
          color: 'var(--color-type-primary)',
          textTransform: 'none',
          whiteSpace: 'pre-line',
          textAlign: 'start',
          margin: 0,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Manrope', sans-serif",
          fontSize: 14,
          fontWeight: 600,
          textTransform: 'none',
          borderRadius: 8,
          padding: '8px 16px',
          lineHeight: 'normal',
          width: 'fit-content',
        },
        containedPrimary: {
          backgroundColor: 'var(--color-type-primary)',
          color: 'var(--color-element)',
          border: '1.5px solid var(--color-type-primary)',
          '&:hover': {
            opacity: 0.9,
          },
        },
        containedSecondary: {
          backgroundColor: 'transparent',
          color: 'var(--color-type-primary)',
          border: '1.5px solid var(--color-type-primary)',
          '&:hover': {
            opacity: 0.9,
          },
        },
      },
    },
  },
});
